import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import moment_ from 'moment';

const moment = moment_;

@Directive({
  selector: '[libDateMask]'
})
export class DateMaskDirective {

constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event);
  }

  @HostListener('blur', ['$event'])
  blur(event) {
    this.onInputBlur(event);
  }

  // Three digits in the value has to be evaluated to determine (where possible)
  // if the pattern of the digits implies one-digit month and two-digit day, or
  // two-digit month and only one digit in the day. If we were to simply take
  // the first two characters as the month at all times, a value of '823' would
  // generate '82/3' and be invalid / non-sensical.
  processThreeDigitValue(input):any {
    console.warn('processTwoDigitValue received input ' + input);
    // Let's not assume that three digits is always a 2-digit month and one-digit day.
    // E.g., user could have entered 123, 130, 027, 615, 921, etc., so let's follow these rules:

    // 1. If the first digit is 0 or 1, and the numeric value of the first two
    //    digits is less than 13, assume that's intended as the month.
    //    Reformat the value as ##/#
    if ( parseInt(input.substring(0,1)) < 2 && parseInt(input.substring(0,2)) < 13 ) {
      return input.substring(0,2) + '/' + input.substring(2);
    }

    // 2. If the first check failed, we have to assume the first digit alone is
    //    the month, and the other two digits are the day.
    //    Reformat the value as 0#/##
    return '0' + input.substring(0, 1) + '/' + input.substring(1);
  }

  formatDayAndMonth(input):any {
    let len = input.length;
    switch(len) {
      case 1:
        // Only possibilities here are a digit or non-digit character. Keep a digit, reject anything else
        if(!/\d/.test(input)){
          input = '';
        }

        break;
      case 2:
        // Only possibilities are one digit and a slash, or two digits.
        // Reformat the former to give the digit a leading '0' (e.g., '02/''); pass the latter case
        // through as-is, since we cannot make any inferences yet about month vs day
        if(/\d\//.test(input)){
          input= '0'+input;
        }

        break;
      case 3:
        // Only possible formats here, based on second character logic executing before the third keystroke are:
        //
        // A) ### -- run it through processThreeDigitValue to figure out where to insert the needed "/"
        // B) ##/ -- do nothing and pass through as-is
        if(/\d{3}/.test(input)){
          input = this.processThreeDigitValue(input);
        }

        break;
      case 4:
        // Only possible formats here, based on second and/or third character logic executing before the fourth keystroke are:
        //
        // A) ##// -- strip out the extra "/"
        // B) ##/# -- do nothing and pass through as-is
        if(/\d{2}\/\//.test(input)) {
          input = input.substring(0,3);
        }

        break;
      case 5:
        // Only possible formats here, based on third and/or fourth character logic executing before the fifth keystroke, are:
        //
        // A) ##/#/ -- insert a zero on the day part, reformatting the value to ##/0#/
        // B) ##/## -- do nothing and pass through as-is
        if(/\d{2}\/\d\//.test(input)) {
          input = input.substring(0,2)+'/0'+input.substring(3,4)+'/';
        }

        break;
    }
    return input;
  }


  onInputChange(event) {
     console.warn('DateMaskDirective received event ' + event + ' in onInputChange')
    let input = event;

    if ( !input ){
      input = '';
    }
    
    input = input.replace(/[a-z]|[A-Z]|\*|\&|\%|\@|\#|\$|\(|\)|\\|\^|\!|\_|\+|\=|\?|\s/g,'');
    input = input.replace(/\-/g, '/')
    let len = input.length;

    switch(len) {
      case 0:
        break;
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        input = this.formatDayAndMonth(input);
        break;
      case 6:
        // Possible formats here, based on formatDayAndMonth processing executing before the sixth keystroke, are:
        //
        // A) ##/### -- insert a slash before the first year digit, reformatting the value to ##/##/#
        // B) ##/##/ -- do nothing and pass through as-is
        if(/\d{2}\/\d{3}/.test(input)){
          input = input.substring(0,5)+'/'+input.substring(5,6);
        }

        break;
      case 7:
        // Possible formats here, based on sixth-character processing executing before the seventh keystroke, are:
        //
        // A) ##/##// -- strip out the extra slash
        // B) ##/##/# -- do nothing and pass through as-is
        if(/\d{2}\/\d{2}\/\//.test(input)) {
          input = input.substring(0,6);
        }

        break;
      case 8:
        // Possible formats here, based on seventh-character processing executing before the eighth keystroke, are:
        //
        // A) ##/##/#/ -- strip out the invalid slash
        // B) ##/##/## -- do nothing and pass through as-is
        if(/\d{2}\/\d{2}\/\d\//.test(input)) {
          input = input.substring(0,7);
        }

        break;
      case 9:
        // Possible formats here, based on eighth-character processing executing before the ninth keystroke, are:
        //
        // A) ##/##/##/ -- strip out the invalid slash
        // B) ##/##/### -- do nothing and pass through as-is
        if(/\d{2}\/\d{2}\/\d{2}\//.test(input)) {
          input = input.substring(0,8);
        }

        break;
      case 10:
        // Possible formats here, based on ninth-character processing executing before the tenth and final keystroke, are:
        //
        // A) ##/##/###/ -- strip out the invalid slash
        // B) ##/##/#### -- do nothing and pass through as-is
        if(/\d{2}\/\d{2}\/\d{3}\//.test(input)) {
          input = input.substring(0,9);
        }

        break;
      default:
        // We've covered lengths 0 through 10, so anything longer should just
        // have the last character rejected outright. Dates can only be 10
        // characters max
        input = input.substring(0,10);
    }
    this.ngControl.valueAccessor.writeValue(input);
  }

  onInputBlur(event: any) {
    // This function will attempt to finish formatting a date value that's incomplete
    let input = event.target.value;
    let inputModfied = false;

    if(!input){
      input = '';
    }
    
    let len = input.length;
    const currYear = moment().year().toString();

    switch(len) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        // Pass through values without complete 2-digit month and day, separated by "/"
        break;
      case 5:
        // Must be in format mm/dd, per the change formatter logic.
        // Append "/" and the current year, regardless of what the entered month
        // and day values are. If they're future, back-end validation will catch
        // that. If they're nonsense values, back-end will catch that as well.
        input = input + '/' + currYear;
        inputModfied = true;
        break;  
      case 6: 
        // Must be in format mm/dd/, per the change formatter logic. Rare that
        // we'll hit this case, but have to cover it.
        // Append the current year to the end of the string.
        input = input + currYear;
        inputModfied = true;
        break;
      case 7:
        // Must be in format mm/dd/y, per the change formatter logic.
        // If the entered year digit matches the first digit of the current year,
        // just append the rest of the year
        const enteredYearChar = input.substring(6);
        const firstDigitOfCurrYear = currYear.charAt(0);
        const restOfCurrYear = currYear.substring(1);
        if ( enteredYearChar ===  firstDigitOfCurrYear) {
          input = input + restOfCurrYear;
          inputModfied = true;
        }
        break;
      case 8:
        // Must be in format mm/dd/yy, per the change formatter logic.
        // Inject the first two digits of the current year before the entered
        // year digits, regardless of whether the entered year is past, present,
        // or future. The back-end will handle checking for future date or other
        // validations.
        input = input.substring(0, 6) + currYear.substring(0,2) + input.substring(6);
        inputModfied = true;
        break;
      case 9:
        // Must be in format mm/dd/yyy, per the change formatter logic.
        // Append the last digit of the current year, but only if the 3 entered
        // year digits match the current year
        const enteredYear = input.substring(6);
        const firstThreeOfCurrYear = currYear.substring(0,3);
        const lastDigitOfCurrYear = currYear.substring(3);

        if ( enteredYear === firstThreeOfCurrYear ) {
          input = input + lastDigitOfCurrYear;
          inputModfied = true;
        }

        break;
      default:
        // Must be the full 10-character value, so do nothing / just pass it through
    }

    // Since we are exiting the form control at this point, we cannot just call
    // writeValue() as that only updates the native DOM element. We also have to
    // update the actual AbstractControl's value and trigger a call to
    // updateValueAndValidity(). However, we should only do this if the input
    // was actually modified and not just passed through. Calling setValue() will
    // also update the DOM element, so no need to separately call writeValue().
    if ( inputModfied ) {
      this.ngControl.control.setValue(input);
    }
  }
}